<button #button mat-icon-button [matTooltip]="'mainLayout.feedbackButton' | translate">
    <mat-icon>feedback</mat-icon>
</button>